// LinkExpiredPage.js
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useEffect } from "react";
 
function LinkExpiredPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading(""))
  }, [])
  return (
    <div className='container-fluid' id="skill_section">
    <div className='row mt-4'>
        <div className='col-sm-10 offset-sm-1 expired-div'>
            <p className='text-center pt-4'>The feedback link is expired.</p>
        </div>
    </div>
</div>
  );
}
 
export default LinkExpiredPage;